import Vue from 'vue';
import Vuex from 'vuex';
import {
  Notification
} from 'element-ui';
import {
  http
} from '../request/api.js';
import createVuexAlong from 'vuex-along';
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    user: {}, //当前登录用户
    allUsers: [], //全部用户
    hasLogin: false, //是否已经登陆了
    todo_count: 0, //待办事项
    copy_count: 0, //抄送事项
    updateUserAt: 0,
  },
  plugins: [createVuexAlong()],
  mutations: {
    UPDATE_TODO_COUNT(state, payload) {
      if (payload.todo_count > state.todo_count) {
        if (state.todo_count == 0) {
          Notification.info({
            title: '待办事项提醒',
            message: `您有 ${payload.todo_count} 条事项待办理，请及时办理`,
            duration: 10000,
            offset: 50
          });
        } else {
          Notification.info({
            title: '待办事项提醒',
            message: `您有新的代办事项，请及时处理`,
            duration: 10000,
            offset: 50
          });
        }
      }
      state.todo_count = payload.todo_count;
      state.copy_count = payload.copy_count;
    },
    LOG_OUT(state) {
      state.todo_count = 0;
      state.user = {};
      state.hasLogin = false;
      sessionStorage.removeItem('user');
    },
    LOGIN(state, payload) {
      state.user = payload.user;
      state.hasLogin = true;
    },
    UPDATE_ALL_USERS(state, payload) {
      state.allUsers = payload.users;
      let now = Date.parse(new Date()) / 1000;
      state.updateUserAt = now;
    }
  },
  actions: {
    updateUserData({
      commit,
      state
    }) {
      http.userData().then(res => {
        if (res.code == 0) {
          commit('UPDATE_TODO_COUNT', {
            todo_count: res.data.todo_count,
            copy_count: res.data.copy_count,
          });
        }
      })
    },
    updateAllUsers({
      commit,
      state
    }) {
      let now = Date.parse(new Date()) / 1000;
      if (now - state.updateUserAt > 60) { //做一个60秒的缓存
        // console.log('update user cache');
        http.allUser().then(res => {
          commit('UPDATE_ALL_USERS', {
            users: res.data
          })
        }).catch(e => {
          console.log('error ')
          console.log(e)
        })
      } else {
        // console.log('use user cache');
      }
    }
  },
  modules: {

  }
})



// WEBPACK FOOTER //
// ./src/store/index.js